// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".price[data-v-fd6dfbee]{display:flex;align-items:center;gap:4px;margin:16px 0 8px;line-height:18px;font-feature-settings:\"palt\" 1}.price .value[data-v-fd6dfbee]{font-size:13px}.price .discount[data-v-fd6dfbee]{padding:0 4px;background:#dc3545;font-size:12px;color:#fff}", ""]);
// Exports
module.exports = exports;
